import Style from "./TasksTableStyle";
import Spinner from "../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import api from "../../services/api";

import { ProgressBar } from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";
import { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle";

export default function Tasks(props) {

  const [tasks, setTasks] = useState([] as any);
  const [deletingTask, setDeletingTask] = useState(false);
  const [taskToDelete, setTaskToDelete] = useState({} as any);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ success: "", error: "" });
  const enterpriseId = props.match.params.enterpriseId;

  useEffect(() => {
    LoadTasks();
  }, []);


  function CreateTask() {
    GoToTaskDetails(-1);
  }

  function GoToTaskDetails(taskId) {
    props.history.push(`/enterprises/${enterpriseId}/tasks/${taskId}`);
  }

  async function DeleteTask() {
    setDeletingTask(true);
    setLoading(true);
    try {
      const result = await api.delete(`/enterprises/${enterpriseId}/tasks/${taskToDelete.id}`);
      if (result.data.success) {
        setMessage({ success: "Tarefa deletada com sucesso!", error: "" });
        setLoading(false);
      } else {
        setMessage({ success: "", error: "Problema ao deletar a tarefa!" });
        setLoading(false);

      }
      await LoadTasks();
      setDeletingTask(false);
      ClosePopupDeletingTask();
    }
    catch (error) {
      setDeletingTask(false);
      ClosePopupDeletingTask();
      setLoading(false);
      setMessage({ success: "", error: "Problema ao deletar a tarefa: " + error });
    }

  }

  async function LoadTasks() {
    setLoading(true);
    try {

      const result = await api.get(`/enterprises/${enterpriseId}/tasks`);
      if (!result.data.success) {
        setMessage({ success: "", error: "Não foi possível consultar tarefas!" });
        setLoading(false);
        return;
      }
      const tasksOrdered = result.data.tasks.sort(Compare);
      setTasks(tasksOrdered);
      setLoading(false);
    }
    catch (error) {
      setLoading(false);
    }
  }

  function Compare(taskA, taskB) {
    if (taskA.orderValue === taskB.orderValue)
      return taskA.id > taskB.id ? 1 : -1;

    return taskA.orderValue > taskB.orderValue ? 1 : -1;
  }

  function ClosePopupDeletingTask() {
    setTaskToDelete({});
  }

  return (
    <Style>
      <PageTitle title="Tarefas do empreendimento" />
      <TwoButtonsModal
        show={taskToDelete.id != null}
        onHide={ClosePopupDeletingTask}
        loading={deletingTask}
        title="Deleção de tarefa!"
        body={`Você está tentando deletar a tarefa "${taskToDelete.name}", essa ação é irreversível!`}
        secondaryText="Fechar"
        secondaryOnClick={ClosePopupDeletingTask}
        secondaryDisabled={deletingTask}
        primaryText="Deletar"
        primaryOnClick={DeleteTask}
        primaryDisabled={deletingTask}
      />
      <button onClick={() => props.history.goBack()} className=" btn-secondary">Voltar</button>
      <Spinner spinning={loading} />
      <section className="table-title">
        <h1>Tarefas</h1>
        <button onClick={CreateTask}>Adicionar Tarefa</button>
      </section>
      {message.error && <p className="alert alert-error">Erro: {message.error}</p>}
      {message.success && <p className="alert alert-info">{message.success}</p>}

      <table className="table table-striped table-bordered table-hover main-table">
        <thead>
          <tr>
            <th>Nome da tarefa</th>
            <th>Porcentagem</th>
            <th>Ordem</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {tasks.length > 0 && tasks.map(task => {
            return (
              <tr key={task.id}>
                <td className="clickable" onClick={() => GoToTaskDetails(task.id)}>{task.name}</td>
                <td className="clickable" onClick={() => GoToTaskDetails(task.id)}><ProgressBar variant="success" now={task.percentage} label={`${task.percentage}%`} /></td>
                <td className="clickable" onClick={() => GoToTaskDetails(task.id)}>{task.orderValue}</td>
                <td >
                  <div className="action"
                    onClick={() => setTaskToDelete(task)}
                  ><FaTrashAlt className="icon" /></div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Style>

  )
}